import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { controlToastState, Modal } from "risa-oasis-ui_v2";
import NewFileUploaderCard from "../../../components/newFileUploader/newFileUploader";
import { ModalId } from "../../../enums/modalId";
import { RootState } from "../../../redux/store/store";
import { AddMore } from "../../../svg/add-more";

interface ManageAttachmentsModalProps {
  onClose: () => void;
  orderId: string;
}

const ManageAttachmentsModal = (props: ManageAttachmentsModalProps) => {
  const [fileNames, setFileNames] = useState<string[]>([
    "Clinical Attachment.pdf",
  ]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isUploading] = useState<boolean>(false);
  const { progress } = useSelector((state: RootState) => state.fileUpload);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files || []);
    const duplicateFiles = newFiles.filter((newFile) =>
      uploadedFiles.some((existingFile) => existingFile.name === newFile.name),
    );

    if (duplicateFiles.length > 0) {
      controlToastState("duplicate-file-upload");
      return;
    }

    const uniqueFiles = newFiles.filter(
      (newFile) =>
        !uploadedFiles.some(
          (existingFile) => existingFile.name === newFile.name,
        ),
    );

    setFileNames((prev) => [...prev, ...uniqueFiles.map((file) => file.name)]);
    setUploadedFiles((prev) => [...prev, ...uniqueFiles]);
  };

  const handleOnSave = async () => {
    // TODO: Implement file upload to Firebase Storage in Sprint 4
    // For now, just close the modal
    controlToastState("attachments-saved-successfully");
    props.onClose();
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleFileDelete = (index: number) => {
    setUploadedFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });

    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };

  return (
    <Modal
      dialogId={ModalId.MANAGE_ATTACHMENTS_MODAL}
      onSave={handleOnSave}
      title={"Manage Attachments"}
      saveButtonText={"Save"}
      cancelText={"Cancel"}
      onClose={handleClose}
      heightPercentage={70}
      disableSave={false}
    >
      <div className="flex flex-col gap-3">
        <p className="text-sm text-gray-600">
          Upload additional clinical documents to support the medical necessity
          review.
        </p>
        {fileNames.map((docName, index) => (
          <NewFileUploaderCard
            key={`${docName}-${index}`}
            fileName={docName}
            progress={progress}
            isUploading={isUploading}
            handleDelete={() => handleFileDelete(index)}
          />
        ))}
        <div
          className="mt-2 flex items-center gap-1 hover:cursor-pointer"
          onClick={handleClick}
        >
          <AddMore />
          <div className="text-h12 font-semibold text-tertiaryBlue-4">
            Add Document
          </div>
          <input
            type="file"
            ref={fileInputRef}
            multiple
            className="hidden"
            onChange={handleFileChange}
            accept=".pdf"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ManageAttachmentsModal;
